import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";   
import usePriceEdgeScheduleSequences from "./hooks/usePriceEdgeScheduleSequences";  
  
const PriceEdgeScheduleSequences = () => {  
  const priceEdgeScheduleSequencesData = usePriceEdgeScheduleSequences();  
  
  return (  
    <div class="container container-fluid"> 
         <ButtonsSection ctaButtons={priceEdgeScheduleSequencesData.leftButtons} align="left" />  
      <div className="header-section">  
        <h1>  
          {priceEdgeScheduleSequencesData.screen_title} -{" "}  
          <span className="heading-cod">  
            {priceEdgeScheduleSequencesData.screenNumber}  
          </span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={priceEdgeScheduleSequencesData.formFields}  
        dropdownValues={priceEdgeScheduleSequencesData.dropdownValues}  
        paramsData={priceEdgeScheduleSequencesData.paramsData}  
        updataParamData={priceEdgeScheduleSequencesData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={priceEdgeScheduleSequencesData.ctaButtons} />  
      <DisplayTable  
        data={priceEdgeScheduleSequencesData.data}  
        parmKey={priceEdgeScheduleSequencesData.parmKey}  
        menuOptions={priceEdgeScheduleSequencesData.menuOptions}  
        tableHeaders={priceEdgeScheduleSequencesData.columnDef}  
        setRowData={priceEdgeScheduleSequencesData.setRowData}  
        selectedPriceSchedules={priceEdgeScheduleSequencesData.selectedRows}  
        setSelectedPriceSchedules={  
          priceEdgeScheduleSequencesData.setSelectedRows  
        }  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={priceEdgeScheduleSequencesData.first}  
          rows={priceEdgeScheduleSequencesData.rows}  
          totalRecords={priceEdgeScheduleSequencesData.totalRecords}  
          currentPage={priceEdgeScheduleSequencesData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={priceEdgeScheduleSequencesData.onPageChange}  
        />  
      </div>  
      {priceEdgeScheduleSequencesData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={priceEdgeScheduleSequencesData.isConfirmationModalOpen}  
          onRequestClose={priceEdgeScheduleSequencesData.closeConfirmationModal}  
          onBack={priceEdgeScheduleSequencesData.closeConfirmationModal}  
          onSave={priceEdgeScheduleSequencesData.deletePriceSchedule}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={priceEdgeScheduleSequencesData.setSelectedOption}  
        />  
      )}  
      {priceEdgeScheduleSequencesData.isInactiveConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={
            priceEdgeScheduleSequencesData.isInactiveConfirmationModalOpen
          }
          onRequestClose={
            priceEdgeScheduleSequencesData.closeInactiveConfirmationModal
          }
          onBack={
            priceEdgeScheduleSequencesData.closeInactiveConfirmationModal
          }
          onSave={
            priceEdgeScheduleSequencesData.inactivateRecord
          }
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={
            priceEdgeScheduleSequencesData.setInactiveSelectedOption
          }
        />
      )}
    </div>  
  );  
};  
  
export default PriceEdgeScheduleSequences; 